import type { CourseEventLane, RaceVariantState } from "./types";

export const RACE_VARIANT_COUNT = 3;

const VARIANT_IDS = ["classic", "switchback", "staggered"] as const;
const ITEM_LAYOUT_IDS = ["full-grid", "split-rows", "offset-rows"] as const;
const HAZARD_LAYOUT_IDS = ["paired", "switchback", "slalom"] as const;

export function normalizeRaceVariantSeed(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value) ? Math.floor(Math.max(0, value)) >>> 0 : 0;
}

export function deriveRaceVariant(seed: unknown, _trackId: string): RaceVariantState {
  const normalizedSeed = normalizeRaceVariantSeed(seed);
  const index = (normalizedSeed % RACE_VARIANT_COUNT) as 0 | 1 | 2;
  return {
    seed: normalizedSeed,
    index,
    id: VARIANT_IDS[index],
    itemLayout: ITEM_LAYOUT_IDS[index],
    hazardLayout: HAZARD_LAYOUT_IDS[index],
  };
}

export function nextRaceVariantSeed(seed: unknown): number {
  return (normalizeRaceVariantSeed(seed) + 1) >>> 0;
}

export function getVariantEventLane(
  variant: Pick<RaceVariantState, "index"> | undefined,
  defaultBlockedLane: CourseEventLane,
  lap: number,
): CourseEventLane {
  const safeLap = Math.max(1, Math.floor(Number.isFinite(lap) ? lap : 1));
  const opposite = (defaultBlockedLane === 1 ? -1 : 1) as CourseEventLane;
  const pattern: readonly CourseEventLane[] = variant?.index === 1
    ? [opposite, defaultBlockedLane, opposite]
    : variant?.index === 2
      ? [defaultBlockedLane, defaultBlockedLane, opposite]
      : [defaultBlockedLane, opposite, defaultBlockedLane];
  return pattern[(safeLap - 1) % pattern.length];
}
